import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderimage from "../image/placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogList } from "../redux/slice/BlogList";
import Loader from "../components/Loader";

export default function BlogList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { blogListData, isLoading, isError } = useSelector(
    (state) => state.BlogList
  );
  useEffect(() => {
    dispatch(fetchBlogList());
  }, [dispatch]);

  return (
    <>
      <div className="container-fluid blog-list-container">
        <HelmetProvider>
          <Helmet>
            <title>Fitness & Gym Blog — Tips, Workouts & Health Advice | MeraGym</title>
            <meta
              name="keywords"
              content="fitness blog, gym tips, workout advice, health blog, exercise tips, bodybuilding, yoga, nutrition, weight loss, meragym blog"
            />
            <meta
              name="description"
              content="Explore MeraGym's fitness blog for expert workout tips, gym guides, nutrition advice, and health inspiration. Stay motivated and achieve your fitness goals."
            />
            <link rel="canonical" href="https://meragym.com/blog" />
            <meta property="og:title" content="Fitness & Gym Blog | MeraGym" />
            <meta property="og:description" content="Expert workout tips, gym guides, nutrition advice, and health inspiration from MeraGym's fitness blog." />
            <meta property="og:url" content="https://meragym.com/blog" />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Fitness & Gym Blog | MeraGym" />
            <meta name="twitter:description" content="Expert workout tips, gym guides, nutrition advice, and health inspiration." />
          </Helmet>
        </HelmetProvider>
        <div className="container mb-3">
          <h1 className="offHead blog-head">Let's Find Latest Helpful Blogs</h1>
          {isLoading ? <Loader /> : null}
          <div className="row">
            {blogListData.map((blogData) => {
              return (
                <div className="col-12 col-sm-6 col-md-4 col-lg-3 py-2" key={blogData.id}>
                  <Link
                    to={`/blog/${blogData.slug}`}
                    className="blog-detail-pg"
                  >
                    <div className="card border-0 blog-list-card">
                      <LazyLoadImage
                        src={blogData.image}
                        placeholderSrc={placeholderimage}
                        loading="lazy"
                        className="blog-list-img"
                        alt={blogData.title}
                      />
                      <div className="card-body">
                        <p className="blog-txt">{blogData.title}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
